module.exports = __webpack_public_path__ + "img/reset_program_icon2.dbe90025.png";